// @ts-nocheck

import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Head from 'react-helmet';
import styled from 'styled-components';

import Button from 'app/shared/core/Button';
import ErrorActions from 'app/shared/flux/actions/ErrorActions';
import Input from 'app/shared/core/Input';
import Linker from 'app/shared/modules/Linker';
import pathsManifest from 'app/shared/utils/pathsManifest';
import Row from 'app/shared/core/Row';
import Section from 'app/shared/modules/Section';
import './style.scss';
import Text from 'app/shared/core/Text';
import UserActions from 'app/shared/flux/actions/UserActions';
import UserSearchActions from 'app/shared/flux/actions/UserSearchActions';

const StyledBoldText = styled(Text)`
  font-weight: 700;
`;
const StyledBoldDiv = styled.div`
  font-weight: 700;
`;
const StyledScoreText = styled(StyledBoldDiv)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;
const StyledCenterTextDiv = styled.div`
  text-align: center;
`;
class NetPromoterScorePage extends Component {
  constructor(props) {
    super(props);
    const { query } = this.props;
    /**
     * HPWEB-3689
     * `replace` is called to remove the whitespace from the decoded date
     * param which caused date calculations via `new Date()` to not work
     * properly in Safari and iOS. The addition of "Z" stands for "Zero UTC
     * Offset" which accounts for the way browsers interpret timezones and
     * streamlines all of them to respect the date in UTC time.
     */
    const dateFromQueryParam =
      query.date && new Date(decodeURIComponent(query.date).replace(/\s/, 'T') + 'Z').getTime();

    this.state = {
      comment: '',
      loading: false,
      date: dateFromQueryParam || Date.now(),
      area: {},
    };
  }
  componentDidMount() {
    const {
      dispatch,
      geolocation,
      query: { score, email, userToken },
    } = this.props;
    const { date } = this.state;

    dispatch(UserSearchActions.getRecentSearches()).then((data) => {
      // Prioritize recent search; geolocation as fallback
      const area = (data && data.areaInfo) || geolocation;

      this.setState({ area });
    });
    dispatch(
      UserActions.updateNetPromoterScore({
        email,
        score,
        userToken,
        date,
      }),
    ).catch((error) => {
      dispatch(
        ErrorActions.errorHandler({
          error,
          errorLocation: 'component.netPromoterScorePage.componentDidMount',
          errorClass: 'userActions',
        }),
      );
    });
  }
  handleTextInput = (e) => {
    this.setState({
      comment: e.target.value,
    });
  };
  handleSubmit = (e) => {
    const { dispatch, query } = this.props;
    const { comment, date } = this.state;
    const { email, score, userToken } = query;
    e.preventDefault();

    this.setState({
      loading: true,
    });

    dispatch(
      UserActions.updateNetPromoterScore({
        email,
        score,
        userToken,
        date,
        comment,
      }),
    )
      .then(() => {
        this.setState({
          loading: false,
        });
        window.router.transitionTo(pathsManifest.FeedbackSuccessPage);
      })
      .catch((error) => {
        // handle error in form
        dispatch(
          ErrorActions.errorHandler({
            error,
            errorLocation: 'component.netPromoterScorePage.handleSubmit',
            errorClass: 'userActions',
          }),
        );
      });
  };
  render() {
    const {
      query: { score },
    } = this.props;
    const { comment, loading, area } = this.state;

    return (
      <StyledCenterTextDiv className="NetPromoterScorePage">
        <Head title="Thank you | HotPads" />
        <div className="NetPromoterScorePage-wrapper">
          <Section>
            <StyledBoldText size="lg">Thanks for your feedback!</StyledBoldText>
            <Row>We have recorded your response.</Row>
            <Row size="md">
              <StyledScoreText className="NetPromoterScorePage-score">{score}</StyledScoreText>
            </Row>
            <Row>Anything else you'd like to share with us?</Row>
            <form>
              <Input
                type="textarea"
                customTagClassName="NetPromoterScorePage-input"
                placeholder="Tell us your thoughts..."
                value={comment}
                onChange={this.handleTextInput}
              />
              <Row size="lg">
                <Button size="lg" full disabled={loading} onClick={this.handleSubmit}>
                  Submit
                </Button>
              </Row>
            </form>
            <StyledBoldDiv>
              <Linker to={area.uriV2}>I'm good! I have nothing to say.</Linker>
            </StyledBoldDiv>
          </Section>
        </div>
      </StyledCenterTextDiv>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    query: state.location.current.query,
    geolocation: state.geolocation.area,
  };
};

export default withRouter(connect(mapStateToProps)(NetPromoterScorePage));
